export default "__VITE_ASSET__But2asUu__"